import React from "react";
import * as styles from "./DefaultBadge.module.scss";

type DefaultBadgeProps = { disabled?: boolean; onSetDefault: () => void };

export const DefaultBadge = () => {
  return <span className={styles.defaultBadge}>Default</span>;
};

export const SetDefaultBadge = ({
  onSetDefault,
  disabled,
}: DefaultBadgeProps) => {
  return (
    <button
      type="button"
      className={styles.setDefaultBadge}
      disabled={disabled}
      onClick={(event) => {
        event.preventDefault();
        onSetDefault();
      }}
    >
      Set Default
    </button>
  );
};
